import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  focusBar: {
    borderColor: Theme.dodgerLightBlue,
    borderRadius: Theme.tileBorderRadius,
    borderWidth: Theme.px(3),
    marginTop: Theme.px(6),
  },
});
